// collection title 
    let url = window.location.pathname;
    if(url == '/collections/new-collection'){
      document.querySelector('.section-header__title').classList.add('main-shop-title')
    }

// collection banners 
    if(url.includes('/collections')){
   
      let pagination = Array.from(document.querySelectorAll('.pagination .page'));     
      let lastItem = pagination[pagination.length - 1];
      let banner = Array.from(document.querySelectorAll('.grid-banner'));
      if(document.querySelector('.pagination')){
        if(Array.from(lastItem.classList).includes('current')){
            
            banner.map(b => {
              b.classList.add('last-page'); 
            })
                
          }
        }else{
          banner.map(b => {
            b.classList.add('last-page'); 
          })
        }
      }